import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { Title } from 'src/app/shared/components/title/title.component';
import { Injectable } from '@angular/core';

@Injectable()
export class JsonConfiguration {
  titleData: Title;
  headerConfiguration: HeaderConfiguration;


  /**
   * Set initial configuration related data and i18n
   */
  constructor() {
    this.setTitleData();
    this.setHeaderConfiguration();
    //this.setDynamicForm();
  }

  /**
   * Set title related data with i18n
   */
  private setTitleData(): void {
    this.titleData = {
      title: '',
    };
  }

  /**
   * Set header related data with i18n
   */
  private setHeaderConfiguration(): void {
    this.headerConfiguration = {
      layoutAlign: 'start start',
      sections: [
      {
        partner:true,
        menu:false,       
        // backButton: {
        //   styles: ['fs_4_underline'],
        //   route: '../calculator'
        // }
        close: {
        route: '../calculator'
        }
      }
      ],
    };
  }
}
